<template>
  <a-modal
    ref="createModal"
    title="组装与零部件对应关系"
    :width="1375"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
    >
      <!-- 来源分类 -->
      <span slot="fpOrgIdTitle">
        <i class="toRequired">*</i>组织（组装）
      </span>
      <template slot="fpOrgId" slot-scope="text, record">
        <global-select
          :dropdownMatchSelectWidth="false"
          :value.sync="record.fpOrgId"
          selectType="selectAssemble"
          requestApi="/system/user/inventOrgAll"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :assembleLabel="true"
          :allowClear="false"
        />
      </template>
      <!-- 来源单位 -->
      <span slot="fpSupplierCodeTitle">
        <i class="toRequired">*</i>组装供应商
      </span>
      <template slot="fpSupplierCode" slot-scope="text, record">
        <!-- <a-select v-model="record.fpSupplierCode">
          <a-select-option v-for="(item) in supportComList" :key="item.realValue">{{ item.label }}</a-select-option>
        </a-select> -->
        <global-select
          :dropdownMatchSelectWidth="false"
          @successCallBack="(val)=>finishProductSupplierGSCallBack(val,record)"
          :value.sync="record.fpSupplierCode"
          selectType="selectSearch"
          :setParams="{orgNo:record.fpOrgId}"
          searchParam="supplierName"
          requestApi="/scp/scpProductionScheduling/findSupplier"
          :selectItem="{ value: 'lookUpCode', label: 'lookUpValue' }"></global-select>
      </template>
      <!-- 折换 -->
      <span slot="ljTypeTitle">
        <span class="toRequired">*零部件类型</span>
      </span>
      <template slot="ljType" slot-scope="text, record">
        <a-select v-model="record.ljType">
          <a-select-option v-for="(item) in componentTypeList" :key="item.realValue">{{ item.label }}</a-select-option>
        </a-select>
      </template>
      <span slot="ljOrgIdTitle">
        <i class="toRequired">*</i>组织（零部件）
      </span>
      <template slot="ljOrgId" slot-scope="text, record">
        <global-select
          :dropdownMatchSelectWidth="false"
          :value.sync="record.ljOrgId"
          selectType="selectAssemble"
          requestApi="/system/user/inventOrgAll"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :assembleLabel="true"
          :allowClear="false"
        />
      </template>

      <span slot="ljSupplierCodeTitle">
        <span class="toRequired">*零部件供应商</span>
      </span>
      <template slot="ljSupplierCode" slot-scope="text, record">
        <!-- <a-select v-model="record.ljSupplierCode">
          <a-select-option v-for="(item) in supportComList" :key="item.realValue">{{ item.label }}</a-select-option>
        </a-select> -->
        <global-select
          :dropdownMatchSelectWidth="false"
          @successCallBack="(val)=>partProductSupplierGSCallBack(val,record)"
          :value.sync="record.ljSupplierCode"
          selectType="selectSearch"
          :setParams="{orgNo:record.ljOrgId}"
          requestApi="/scp/scpProductionScheduling/findSupplier"
          searchParam="supplierName"
          :selectItem="{ value: 'lookUpCode', label: 'lookUpValue' }"></global-select>
      </template>
      <!-- 倒数 -->
      <template slot="conversionRateInverse" slot-scope="text, record">
        <span>{{ record.conversionRateInverse }}</span>
      </template>
      <!-- 基本单位 -->
      <span slot="isFirstChooseTitle">
        <!-- <i class="toRequired">*</i>首选 -->
        首选
      </span>
      <template slot="isFirstChoose" slot-scope="text, record">
        <a-switch :checked="record.isFirstChoose === 'Y'" @change="statusOnChange(record)" />
      </template>
      <template slot="proportion" slot-scope="text, record">
        <a-input-number v-model="record.proportion" :min="0" />
      </template>
      <template slot="fpProduceEarlyTime" slot-scope="text, record">
        <a-input-number v-model="record.fpProduceEarlyTime" :min="0" />
      </template>
      <template slot="ljProduceEarlyTime" slot-scope="text, record">
        <a-input-number v-model="record.ljProduceEarlyTime" :min="0" />
      </template>
      <template slot="componentAssemblyLeadTime" slot-scope="text, record">
        <a-input-number v-model="record.componentAssemblyLeadTime" :min="0" :precision="0" />
      </template>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDelete(typeList, record)">删除</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import { apiUpdateProductionSchedulinglistfdxiala, apiUpdateProductionSchedulingsearchljtype, apiAddProductionScheduling } from '@/api/scp/dailyProductionPlan/dailyProductionPlan'

// 表单字段
export default {
  props: {
    uomClassOptions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 状态数据字典
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '组织（组装）',
          dataIndex: 'fpOrgId',
          width: 140,
          scopedSlots: { customRender: 'fpOrgId', title: "fpOrgIdTitle" }
        },
        {
          // title: '组装供应商',
          width: 140,
          dataIndex: 'fpSupplierCode',
          scopedSlots: { customRender: 'fpSupplierCode', title: "fpSupplierCodeTitle" }
        },
        {
          // title: '零部件类型',
          width: 140,
          dataIndex: 'ljType',
          scopedSlots: { customRender: 'ljType', title: "ljTypeTitle" }
        },
        {
          // title: '组织（组装）',
          dataIndex: 'ljOrgId',
          width: 140,
          scopedSlots: { customRender: 'ljOrgId', title: "ljOrgIdTitle" }
        },
        {
          // title: '零部件供应商',
          width: 140,
          dataIndex: 'ljSupplierCode',
          scopedSlots: { customRender: 'ljSupplierCode', title: "ljSupplierCodeTitle" }
        },
        {
          // title: '*首选',
          dataIndex: 'isFirstChoose',
          width: 80,
          scopedSlots: { customRender: 'isFirstChoose', title: "isFirstChooseTitle" }
        },
        {
          title: '比例',
          width: 80,
          dataIndex: 'proportion',
          scopedSlots: { customRender: 'proportion' }
        },
        {
          title: '组装提前期',
          width: 80,
          dataIndex: 'fpProduceEarlyTime',
          scopedSlots: { customRender: 'fpProduceEarlyTime' }
        },
        {
          title: '零件提前期',
          width: 80,
          dataIndex: 'ljProduceEarlyTime',
          scopedSlots: { customRender: 'ljProduceEarlyTime' }
        },
        {
          title: '零部件对组装提前期',
          width: 80,
          dataIndex: 'componentAssemblyLeadTime',
          scopedSlots: { customRender: 'componentAssemblyLeadTime' }
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      typeList: [],
      unitOfMeasureList: [],
      supportComList: [],
      componentTypeList: []
    }
  },
  created () {
    // this.getSupportComList()
    this.getComponentTypeList()
  },
  methods: {
    finishProductSupplierGSCallBack (val, record) {
      if (record.fpOrgId && val) { record.fpSupplierCode = val[0].lookUpCode }
    },
    partProductSupplierGSCallBack (val, record) {
      if (record.ljOrgId && val) { record.ljSupplierCode = val[0].lookUpCode }
    },
    statusOnChange (record) {
        record.isFirstChoose = record.isFirstChoose === 'Y' ? 'N' : 'Y'
     },
    getComponentTypeList () {
      apiUpdateProductionSchedulingsearchljtype().then(res => {
        if (res.code === 200 && res.data) {
          this.componentTypeList = res.data
        }
      })
    },
    getSupportComList () {
     const params = {
         type: 4
      }
      apiUpdateProductionSchedulinglistfdxiala(params).then(res => {
        if (res.code === 200 && res.data) {
          this.supportComList = res.data
        }
      })
    },
    blur (record) {
      if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        this.$message.warning('折换不能为空且需大于0')
      } else {
        record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
      }
    },
    // handleSelect (record) {
    //   const params = {
    //     unitOfMeasure: record.unitOfMeasure
    //   }
    //   unitToDatalist(params).then(res => {
    //     if (res.code === 200 && res.data) {
    //       record.uomClassLabel = res.data.comboBoxVO.realValue
    //       record.uomClass = res.data.comboBoxVO.label
    //       record.baseUnitOfMeasure = res.data.baseUnitOfMeasure
    //     }
    //   })
    // },
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.addLine()
      this.visible = true
    },
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.typeList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        fpProduceEarlyTime: "",
        ljProduceEarlyTime: "",
        componentAssemblyLeadTime: "",
        ljOrgId: "",
        fpOrgId: "",
        fpSupplierCode: "",
        ljType: "",
        ljSupplierCode: "",
        isFirstChoose: "N",
        proportion: "",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.typeList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    confirm () {
      if (this.typeList.length === 0) {
        this.$message.warning('请保存至少一个版本信息')
        return false
      }
      let flag = false
      for (let i = 0; i < this.typeList.length; i++) {
        if (!this.typeList[i].fpOrgId ||
        !this.typeList[i].fpSupplierCode ||
        !this.typeList[i].ljType ||
        !this.typeList[i].ljSupplierCode ||
        !this.typeList[i].ljOrgId
        // !this.typeList[i].isFirstChoose
        ) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiAddProductionScheduling(this.typeList).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 130px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
